import { put } from "redux-saga/effects";

import actions from "@/actions";

const getMessageByToolName = (toolName) => {
    switch (toolName) {
        case "search":
        case "filter":
            return "You can select an individual light to view or edit it’s properties. If you want to edit all matching lights, or move them as a group, choose the “Select Matches” button.";
        case "subtract":
            return "Press and drag to deselect lights.";
        case "zoom":
            return "Pinch or expand to zoom in and out. Light selection is disabled.";
        default:
            return "";
    }
};

/**
 * Handles tool selection by updating the information message and active tool state.
 *
 * @param root0 - The action.
 * @param root0.payload - The selected tool identifier.
 * @yields Dispatches tool selection and information message updates.
 */
function* selectTool({ payload }) {
    try {
        yield put(
            actions.window.setInformation(
                getMessageByToolName(!payload ? "" : payload.name),
            ),
        );
        yield put(actions.map.general.setSelectedTool(payload));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on selecting tool:", err);
    }
}

export default selectTool;
